module.exports = __webpack_public_path__ + "img/kr.7fb0181b.svg";